export default "__VITE_ASSET__D_obfC3V__"